import React, { useState, useEffect } from "react";
import UserContext from "./UserContext";

// One-time cleanup: legacy versions of this provider stringified the entire
// Cognito user object into localStorage and could blow past the ~5MB quota
// after a Google social sign-in. Drop any leftover entry on module load so
// returning users don't carry the bloat.
try {
  if (typeof window !== "undefined" && window.localStorage) {
    window.localStorage.removeItem("user");
  }
} catch (_) {}

function UserContextProvider({ children }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  // Don't persist `user` — App.js rehydrates via Auth.currentAuthenticatedUser()
  // on mount, and Amplify already caches its own tokens in localStorage.
  const [user, setUser] = useState(null);
  const [subscriptionType, setSubscriptionType] = useState(
    localStorage.getItem("subscriptionType") || ""
  );
  useEffect(() => {
    try {
      localStorage.setItem("subscriptionType", subscriptionType || "");
    } catch (_) {}
  }, [subscriptionType]);
  return (
    <UserContext.Provider
      value={{
        name,
        setName,
        email,
        setEmail,
        setUser,
        user,
        setSubscriptionType,
        subscriptionType
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

export default UserContextProvider;
